import SendbirdChat from "@sendbird/chat"
import { GroupChannel, GroupChannelModule } from "@sendbird/chat/groupChannel"

const SENDBIRD_INFO = process.env.NEXT_PUBLIC_SENDBIRD_KEY || ""

export const sendbirdChat = SendbirdChat.init({
  appId: SENDBIRD_INFO,
  localCacheEnabled: true,
  modules: [new GroupChannelModule()],
})

export const createChannel = async (
  channelName: string,
  userIdsToInvite: string[],
  propertyId?: string,
  pmc_id?: string,
  coverUrl?: string,
  name?: string,
  mobile_number?: string,
  email?: string,
  dialer_code?: string,
  traveler_id?: string,
  host_id?: string,
): Promise<GroupChannel> => {
  try {
    // const groupChannelParams = {};
    // groupChannelParams.invitedUserIds = userIdsToInvite;
    // groupChannelParams.name = channelName;
    // groupChannelParams.operatorUserIds = userIdsToInvite;
    const groupChannel = await sendbirdChat.groupChannel.createChannel({
      invitedUserIds: userIdsToInvite,
      name: channelName,
      coverUrl: coverUrl,
      data: JSON.stringify({
        property_id: propertyId,
        pmc_id: pmc_id,
        name: name,
        mobile_number: mobile_number,
        email: email,
        dialer_code: dialer_code,
        traveler_id: traveler_id,
        host_id: host_id?.toString(),
      }),
    })
    return groupChannel
  } catch (error) {
    throw new Error("Failed to create Sendbird channel")
  }
}
